import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer6GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Игрок 1"
        attackSignal="random1_attack"
        healSignal="random1_heal"
        attackDescription="Большая пуля летит в сторону души. Урон 15."
        healDescription="Пластыри появляются по всему полю. Лечение 4."
    />
);
